export type UserDataType = {
  mobilePhone: string;
  jobTitle: string;
  jobType: string;
  isStudent: boolean;
  initials: string;
  groupId: number;
  groupName: string;
  email: string;
  lastName: string;
  firstName: string;
  fullName: string;
};

/**
 * Retrieves the current user data from local storage with camel cased keys.
 * User data must exist in `mage-cache-storage`.
 *
 * @returns {UserDataType | null} - An object containing user details (e.g., name, email, job, tier),
 * or `null` if no relevant data is found in local storage.
 */
export const getCurrentUserData = (): UserDataType | null => {
  const localStorageData = localStorage.getItem('mage-cache-storage');
  if (localStorageData) {
    const localStorageObject = JSON.parse(localStorageData);
    const customerData = localStorageObject.customer;
    return {
      // Personal info
      firstName: customerData.firstname,
      lastName: customerData.lastname,
      fullName: customerData.name,
      initials: customerData.initials,
      email: customerData.email,
      mobilePhone: customerData.mobile_phone,
      // Job
      jobTitle: customerData.job_title,
      jobType: customerData.job_type,
      // Tier
      isStudent: customerData.isStudent,
      groupId: customerData.groupId,
      groupName: customerData.groupName,
    };
  }
  return null;
};
